import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    constructor(
        private http: HttpClient,
    ) { }

    /**
     * Get country data
     */
    getCountries(): Observable<countriesGetResponse> {
        return this.http.get<countriesGetResponse>(`${environment.apiUrl}data/countries`);
    }

    /**
     * Get horeca open status
     */
    getHorecaOpenStatus(): Observable<horecaOpenStatusResponse> {
        return this.http.get<horecaOpenStatusResponse>(`${environment.apiUrl}data/horeca_open_status`);
    }

    /**
     * Get horeca open status
     */
    updateHorecaOpenStatus(open: boolean): Observable<horecaOpenStatusResponse> {
        return this.http.post<horecaOpenStatusResponse>(`${environment.apiUrl}data/horeca_open_status`, {
            open: open,
        });
    }

    /**
     * Get horeca open status
     */
    getHorecaInfo(): Observable<horecaInfoResponse> {
        return this.http.get<horecaInfoResponse>(`${environment.apiUrl}data/horeca_info`);
    }

    /**
     * Get horeca open status
     */
    updateHorecaInfo(info: string): Observable<horecaInfoResponse> {
        return this.http.post<horecaInfoResponse>(`${environment.apiUrl}data/horeca_info`, {
            info: info,
        });
    }
}

export interface countriesGetResponse {
    countries: {
        id: string;
        name: string;
    }[];
}

export interface horecaOpenStatusResponse {
    open: boolean;
}

export interface horecaInfoResponse {
    info: string;
}
